var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _c(
        "carousel",
        {
          staticClass: "plane_carrousel",
          staticStyle: { width: "100%" },
          attrs: {
            autoplay: _vm.autoplay,
            "autoplay-hover-pause": "",
            "per-page": 1,
            "pagination-enabled": false,
            loop: "",
            "navigate-to": _vm.index - 1
          },
          on: {
            input: function($event) {
              _vm.onCarouselInput($event)
            }
          }
        },
        _vm._l(_vm.planeExamples, function(example, index) {
          return _c(
            "slide",
            { key: index },
            [
              _c(
                !!example.url ? "a" : "div",
                {
                  tag: "component",
                  staticClass: "home-plane-examples-bloc",
                  attrs: { href: example.url }
                },
                [
                  _c("img", { attrs: { src: example.thumb_url } }),
                  _vm._v(" "),
                  _c("p", { staticClass: "name" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(example.plane_model.name) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(example.description) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "home-plane-examples-bloc-infos" }, [
                    _c(
                      "div",
                      { staticClass: "home-plane-examples-bloc-infos-speed" },
                      [
                        _c("img", {
                          attrs: { src: "/imgs/icons/vitesse.svg" }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "key" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("home.speed")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(example.plane_model.vitesseCroisiere) +
                              " km/h\n                        "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "home-plane-examples-bloc-infos-passengers"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/imgs/icons/passagers.svg" }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "key" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("home.passengers")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(example.plane_model.nbPassagerMax) +
                              " max\n                        "
                          )
                        ])
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("DotNavigation", {
        attrs: {
          "page-count": _vm.planeExamples.length,
          value: _vm.index,
          "primary-color": _vm.primaryColorSlider
        },
        on: {
          input: function($event) {
            _vm.navigateTo($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4097a9c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4097a9c4","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PlaneExamplesCarousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4097a9c4","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PlaneExamplesCarousel.vue
// module chunks = 1 2 3